import styles from '../index.module.scss'
import { Stack, Typography } from '@mui/material'
import sparkLogo from '../../../assets/images/share/sparkIcon_hr.png'
import FallbackHeader from '../../../components/Header/components/FallbackHeader'
import AppleButton from '../../../components/SharedButtons/AppleButton'
import GooglePlayButton from '../../../components/SharedButtons/GooglePlayButton'
import mainImg from '../../../assets/images/dashboard/mobile-fallback-school.png'

const SchoolMobileFallback = () => {
    return (
        <Stack
            sx={{
                height: '100dvh',
                overflowX: 'hidden',
                overflowY: 'auto',
            }}
        >
            <FallbackHeader />
            <Stack
                alignItems={'center'}
                gap={5}
                mt={3}
                sx={{
                    width: 800,
                    maxWidth: '95%',
                    alignSelf: 'center',
                }}
            >
                <Stack gap={3} textAlign={'center'} alignItems={'center'}>
                    <img
                        src={sparkLogo}
                        alt="Spark Relief Teachers"
                        style={{ height: 'auto', width: 200 }}
                    />
                    <Typography variant="h6" fontWeight={600}>
                        Looking to book staff?
                    </Typography>
                    <Typography>
                        Log in from your desktop or laptop to access the web
                        app, or{' '}
                        <span
                            style={{
                                color: styles.primaryBlue500,
                                fontWeight: 600,
                            }}
                        >
                            download
                        </span>{' '}
                        the mobile app and start booking teachers in your area
                        today!
                    </Typography>
                </Stack>

                <Stack direction={'row'} gap={3} alignItems={'center'}>
                    <AppleButton />
                    <GooglePlayButton />
                </Stack>
                <img
                    src={mainImg}
                    style={{ width: 400, maxWidth: '90%', height: 'auto' }}
                />
            </Stack>
        </Stack>
    )
}

export default SchoolMobileFallback
